<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
========================================================================================== -->

<template>
<div id="mes-bls" class="data-list-container">
    <vs-popup fullscreen title="Détail BL" :active.sync="popupActive">
        <div class="vx-card">
            <table style="width:100%" class="border-collapse">
                <tr>
                    <th class="border border-solid d-theme-border-grey-light vx-col md:w-1/5 w-full text-center">Code Article</th>
                    <th class="border border-solid d-theme-border-grey-light vx-col md:w-2/5 w-full text-center">Désignation article</th>
                    <th class="border border-solid d-theme-border-grey-light vx-col md:w-1/5 w-full text-center">Prix</th>
                    <th class="border border-solid d-theme-border-grey-light vx-col md:w-1/5 w-full text-center">Quantité</th>
                </tr>
                <tr :key="indextr" v-for="(tr, indextr) in commandesSelected">
                    <td class="p-2 border border-solid d-theme-border-grey-light vx-col md:w-1/5 w-full text-center">{{tr.No}}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light vx-col md:w-2/5 w-full text-center">{{tr.Description}}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light vx-col md:w-1/5 w-full text-center">{{tr.Amount_Including_VAT}}</td>
                    <td class="p-2 border border-solid d-theme-border-grey-light vx-col md:w-1/5 w-full text-center">{{tr.Quantity}}</td>
                </tr>
            </table>
        </div>
    </vs-popup>

    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="commandes">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <div class="flex flex-wrap-reverse items-center data-list-btn-container">
                <!-- ACTION - DROPDOWN -->
                <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">
                    <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
                        <span class="mr-2">Actions</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>

                    <vs-dropdown-menu>
                        <vs-dropdown-item @click="$refs.myPdfComponent.print()">
                            <span class="flex items-center">
                                <feather-icon icon="PrinterIcon" svgClasses="h-4 w-4" class="mr-2" />
                                <span>Imprimer</span>
                            </span>
                        </vs-dropdown-item>

                        <vs-dropdown-item @click="exportToExcel">
                            <span class="flex items-center">
                                <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                                <span>Exporter Excel</span>
                            </span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="exportToCsv">
                            <span class="flex items-center">
                                <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                                <span>Exporter Csv</span>
                            </span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="exportToTxt">
                            <span class="flex items-center">
                                <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                                <span>Exporter Txt</span>
                            </span>
                        </vs-dropdown-item>

                        <!-- <vs-dropdown-item>
                            <span class="flex items-center">
                                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                                <span>Archiver</span>
                            </span>
                        </vs-dropdown-item> -->
                    </vs-dropdown-menu>
                </vs-dropdown>

                <flat-pickr :config="configFromdateTimePicker" v-model="dateMin" placeholder="Du" @on-change="onFromChange" class="dd-actions cursor-pointer mr-4 mb-4" />
                <flat-pickr :config="configTodateTimePicker" v-model="dateMax" placeholder="Au" @on-change="onToChange" class="dd-actions cursor-pointer mr-4 mb-4" />

            </div>

            <!-- ITEMS PER PAGE -->
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
                <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ commandes.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : commandes.length }} of {{ queriedItems }}</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                    <vs-dropdown-item @click="itemsPerPage=7">
                        <span>7</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=15">
                        <span>15</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=25">
                        <span>25</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=35">
                        <span>35</span>
                    </vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>
        </div>

        <template slot="thead">
            <vs-th sort-key="ncommande">N° Commande</vs-th>
            <vs-th sort-key="date_livraison">Date Livraison</vs-th>
            <vs-th sort-key="nbl">N° BL</vs-th>
            <vs-th sort-key="type">Type</vs-th>

            <vs-th>Action</vs-th>
        </template>

        <template slot-scope="{data}">
            <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        <p class="product-name font-medium truncate">{{ tr.Order_No }}</p>
                    </vs-td>

                    <vs-td>
                        <p>{{ tr.Posting_Date.substring(0,10) }}</p>
                    </vs-td>

                    <vs-td>
                        <p>{{ tr.No }}</p>
                    </vs-td>

                    <vs-td>
                        <div v-if="tr.Order_Type.replace(/\s/g, '') != ''">
                            <p v-if="tr.Order_Type=='Ordinary'">Ordinaire</p>
                            <p v-else-if="tr.Order_Type=='Urgent'">Urgente</p>
                            <p v-else-if="tr.Order_Type=='Normal'">Normale</p>
                            <p v-else>{{tr.Order_Type}}</p>
                        </div>
                        <p v-else> ------- </p>
                    </vs-td>

                    <vs-td>
                        <feather-icon icon="InfoIcon" color="primary" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click="OpenModal( tr.No)" />
                        <feather-icon icon="PrinterIcon" color="primary" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop />
                    </vs-td>
                </vs-tr>
            </tbody>
        </template>
    </vs-table>
    <pdf v-show="showpdf" ref="myPdfComponent" :src="baseUrl"></pdf>
</div>
</template>

<script>
import {
    axiosConfig
} from "@/axios.js";

import indexRetour from "../../http/requests/retour/index.js";
import index from "../../http/requests/bonLivraison/index.js";
import pdf from 'vue-pdf';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    components: {
        pdf,
        flatPickr
    },
    data() {
        return {
            dateMin: null,
            dateMax: null,
            configFromdateTimePicker: {
                minDate: null,
                maxDate: new Date()
            },
            configTodateTimePicker: {
                minDate: null,
                maxDate: new Date()
            },
            commandesOrigin: [],
            showpdf: false,
            printDetails: false,
            popupActive: false,
            itemsPerPage: 10,
            isMounted: false,
            commandes: [],
            commandesSelected: [],
            cellAutoWidth: true,
            headerTitle: ["N° Commande", "Commandé Par", "Date Livraison", "N° BL", "Type", "N° Tour", "Status"],
            headerVal: ["Order_No", "Ship_to_Name", "Posting_Date", "No", "Order_Type", "Tour_No", "Status"],
        };
    },
    watch: {
        commandes: function (val) {
            if (val.length > 0) {
                this.$vs.loading.close("#mes-bls > .con-vs-loading");
            }
        }
    },
    computed: {
        baseUrl() {
            if (this.printDetails)
                return axiosConfig.baseURL +
                    "/reporting/files/"
            else
                return axiosConfig.baseURL +
                    "/reporting/files/listbl/" +
                    this.$store.state.AppActiveUser.customer_No + "/" + this.$store.state.AppActiveUser.displayName.replace(/\s/g, '');
        },
        currentPage() {
            if (this.isMounted) {
                return this.$refs.table.currentx;
            }
            return 0;
        },
        queriedItems() {
            return this.$refs.table ?
                this.$refs.table.queriedResults.length :
                this.commandes.length;
        },
        activeUserInfo() {
            return this.$store.state.AppActiveUser;
        }
    },
    methods: {
        onFromChange(selectedDates, dateStr) {
            if (dateStr == '') {
                if (this.dateMax != null && this.dateMax != '') {
                    this.commandes = this.commandesOrigin.filter(el => {
                        return el.Posting_Date.substring(0, 10) <= this.dateMax
                    })
                } else {
                    this.commandes = this.commandesOrigin;
                }
            } else if (this.dateMax != null && this.dateMax != '') {
                this.commandes = this.commandesOrigin.filter(el => {
                    return el.Posting_Date.substring(0, 10) >= dateStr &&
                        el.Posting_Date.substring(0, 10) <= this.dateMax
                })
            } else {
                this.commandes = this.commandesOrigin.filter(el => {
                    return el.Posting_Date.substring(0, 10) >= dateStr
                })
            }
            this.$set(this.configTodateTimePicker, 'minDate', dateStr);
        },
        onToChange(selectedDates, dateStr) {
            if (dateStr == '') {
                if (this.dateMin != null && this.dateMin != '') {
                    this.commandes = this.commandesOrigin.filter(el => {
                        return el.Posting_Date.substring(0, 10) >= this.dateMin
                    })
                } else {
                    this.commandes = this.commandesOrigin;
                }
            } else if (this.dateMin != null && this.dateMin != '') {
                this.commandes = this.commandesOrigin.filter(el => {
                    return el.Posting_Date.substring(0, 10) <= dateStr &&
                        el.Posting_Date.substring(0, 10) >= this.dateMin
                })
            } else {
                this.commandes = this.commandesOrigin.filter(el => {
                    return el.Posting_Date.substring(0, 10) <= dateStr
                })
            }
            this.$set(this.configFromdateTimePicker, 'maxDate', dateStr);
        },
        getListCommandes() {
            index.GetAll(this.$store.state.AppActiveUser.customer_No).then(response => {
                    this.commandes = response.data.value;
                    this.commandesOrigin = response.data.value;
                })
                .catch(error => {
                    this.$vs.loading.close("#mes-bls > .con-vs-loading");
                    this.$vs.loading.close();
                    this.$vs.notify({
                        title: "Erreur s'est produite lors de la récupération des données",
                        text: error.data,
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circles"
                    });
                });
        },
        getOrderStatusColor(status) {
            if (status == "en_cours") return "warning";
            if (status == "livrée") return "success";
            if (status == "expédiée") return "danger";
            return "primary";
        },
        getPopularityColor(num) {
            if (num > 90) return "success";
            if (num > 70) return "primary";
            if (num >= 50) return "warning";
            if (num < 50) return "danger";
            return "primary";
        },
        OpenModal(numero) {
            this.$vs.loading()
            var today = new Date();
            var dd = String(today.getDate()).padStart(2, "0");
            var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
            var yyyy = today.getFullYear();
            today = yyyy + "-" + mm + "-" + dd;
            indexRetour.getAll(this.$store.state.AppActiveUser.customer_No, today, numero).then(response => {
                    this.commandesSelected = response.data.value;
                    this.$vs.loading.close();
                    this.popupActive = true;
                })
                .catch(error => {
                    console.log(error)
                });
        },
        exportToExcel() {
            import('@/vendor/Export2Excel').then(excel => {
                console.log(this.commandes)
                const data = this.formatJson(this.headerVal, this.commandes)
                excel.export_json_to_excel({
                    header: this.headerTitle,
                    data,
                    filename: this.fileName,
                    autoWidth: this.cellAutoWidth,
                    bookType: "xlsx"
                })
                //this.clearFields()
            })
        },
        exportToCsv() {
            import('@/vendor/Export2Excel').then(excel => {
                console.log(this.commandes)
                const data = this.formatJson(this.headerVal, this.commandes)
                excel.export_json_to_excel({
                    header: this.headerTitle,
                    data,
                    filename: this.fileName,
                    autoWidth: this.cellAutoWidth,
                    bookType: "csv"
                })
                //this.clearFields()
            })
        },
        exportToTxt() {
            import('@/vendor/Export2Excel').then(excel => {
                console.log(this.commandes)
                const data = this.formatJson(this.headerVal, this.commandes)
                excel.export_json_to_excel({
                    header: this.headerTitle,
                    data,
                    filename: this.fileName,
                    autoWidth: this.cellAutoWidth,
                    bookType: "txt"
                })
                //this.clearFields()
            })
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => {
                // Add col name which needs to be translated
                // if (j === 'timestamp') {
                //   return parseTime(v[j])
                // } else {
                //   return v[j]
                // }

                return v[j]
            }))
        },
        clearFields() {
            this.filename = "",
                this.cellAutoWidth = true,
                this.selectedFormat = "xlsx"
        }
    },
    created() {
        if (this.$store.state.AppActiveUser.id != 0) {
            this.getListCommandes();
        }
        this.$store.subscribe(mutation => {
            if (mutation.type === "UPDATE_USER_INFO") {
                this.getListCommandes();
            }
        });
    },
    mounted() {
        this.isMounted = true;
        this.$vs.loading({
            background: this.backgroundLoading,
            // color: this.colorLoading,
            type: 'radius',
            container: "#mes-bls",
            scale: 0.45,
            clickEffect: true
        });
    }
};
</script>

<style lang="scss">
#mes-bls {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000000;

    .vs-table {
        border-collapse: separate;
        // border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr {
            box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.05);

            td {
                align-items: center;
                justify-content: center;
                text-align: center;
                vertical-align: middle;

                &:first-child {
                    border-top-left-radius: 0.5rem;
                    border-bottom-left-radius: 0.5rem;
                }

                &:last-child {
                    border-top-right-radius: 0.5rem;
                    border-bottom-right-radius: 0.5rem;
                }

                &.img-container {
                    span {
                        display: flex;
                        justify-content: flex-start;
                    }

                    .product-img {
                        height: 110px;
                    }
                }
            }
        }

        .vs-table--thead {
            th {
                padding-top: 5;
                padding-bottom: 5;
                color: "primary";
                background: #002b5c;
                justify-content: center;

                .vs-table-text {
                    //text-transform: uppercase;
                    font-weight: 600;
                    color: white;
                    justify-content: center;
                }
            }
        }
    }

    @media (max-width: 461px) {
        .items-per-page-handler {
            display: none;
        }
    }

    @media (max-width: 341px) {
        .data-list-btn-container {
            width: 100%;

            .dd-actions,
            .btn-add-new {
                width: 100%;
                margin-right: 0 !important;
            }
        }
    }

    .product-name {
        max-width: 23rem;
    }

    .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;

        >span {
            display: flex;
            flex-grow: 1;
        }

        .vs-table--search {
            padding-top: 0;

            .vs-table--search-input {
                padding: 0.9rem 2.5rem;
                font-size: 1rem;

                &+i {
                    left: 1rem;
                }

                &:focus+i {
                    left: 1rem;
                }
            }
        }
    }
}
</style>
